import { useEffect, useRef, useState } from "react";
import { ReactLenis } from "lenis/react";
import "@/App.css";
import { LanguageProvider } from "./nexcip/LanguageContext";
import { PromoBanner } from "./nexcip/PromoBanner";
import { Header } from "./nexcip/Header";
import { Hero } from "./nexcip/Hero";
import { MarqueeBanner } from "./nexcip/MarqueeBanner";
import { Partners } from "./nexcip/Partners";
import { Products } from "./nexcip/Products";
import { AppShowcase } from "./nexcip/AppShowcase";
import { Features } from "./nexcip/Features";
import { Testimonials } from "./nexcip/Testimonials";
import { HowItWorks } from "./nexcip/HowItWorks";
import { FAQ } from "./nexcip/FAQ";
import { Footer } from "./nexcip/Footer";
import { ChatWidget } from "./nexcip/ChatWidget";

function App() {
  const lenisRef = useRef(null);
  const [bannerOpen, setBannerOpen] = useState(true);

  useEffect(() => {
    document.title = "NEXCIP by Lima Cipta Digital — Top Up Tanpa Batas";
    if (typeof window !== "undefined") {
      window.__lenis = () => lenisRef.current?.lenis;
    }
  }, []);

  return (
    <LanguageProvider>
      <ReactLenis ref={lenisRef} root options={{ lerp: 0.09, smoothWheel: true }}>
        <div className="nx-grain relative min-h-screen bg-[#050505] text-white antialiased">
          <PromoBanner open={bannerOpen} onClose={() => setBannerOpen(false)} />
          <Header bannerOpen={bannerOpen} />
          <main>
            <Hero />
            <MarqueeBanner />
            <Partners />
            <Products />
            <AppShowcase />
            <Features />
            <Testimonials />
            <HowItWorks />
            <FAQ />
          </main>
          <Footer />
          <ChatWidget />
        </div>
      </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
